import styles from './index.module.scss';

export default function Loader() {
  return (
    // loader component
    <div className={styles["loader"]}></div>
  )
}
